import Conditions from '../../../../../resources/conditions';
import { Responses } from '../../../../../resources/responses';
import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

// TODO: Add better (directional?) callout for Drowsie's Wallop (ivy cleaves)

export type Data = RaidbossData;

const triggerSet: TriggerSet<Data> = {
  id: 'Ihuykatumu',
  zoneId: ZoneId.Ihuykatumu,
  timelineFile: 'ihuykatumu.txt',
  triggers: [
    // ** Prime Punutiy ** //
    {
      id: 'Ihuykatumu Prime Punutiy Punutiy Press',
      type: 'StartsUsing',
      netRegex: { id: '8E8C', source: 'Prime Punutiy', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Ihuykatumu Prime Punutiy Decay',
      type: 'StartsUsing',
      netRegex: { id: '8E99', source: 'Ihuykatumu Flytrap', capture: false },
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Get under Flytrap',
          de: 'Geh unter die Fliegenfalle',
          fr: 'Allez sous le piège à vent',
          ja: 'ドーナツ範囲に入る',
          cn: '进入月环',
          ko: '파리풀 아래로',
          tc: '進入月環',
        },
      },
    },
    {
      id: 'Ihuykatumu Prime Punutiy Inhale',
      type: 'StartsUsing',
      netRegex: { id: '8E8E', source: 'Prime Punutiy', capture: false },
      durationSeconds: 10, // prolonged ground damage
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Stay out of inhale',
          de: 'Steh auserhalb des Soges',
          fr: 'Sortez du Turbinage',
          ja: '吸い込む範囲から離れる',
          cn: '躲开 Boss 吸气 + 全场 AoE',
          ko: '흡입 범위에서 벗어나 있기',
          tc: '躲開Boss吸氣 + 全場AOE',
        },
      },
    },
    {
      id: 'Ihuykatumu Prime Punutiy Shore Shaker',
      type: 'StartsUsing',
      netRegex: { id: '8EA2', source: 'Prime Punutiy', capture: false },
      durationSeconds: 6,
      response: Responses.getOutThenIn(),
    },

    // ** Drowsie ** //
    {
      id: 'Ihuykatumu Drowsie Uppercut',
      type: 'StartsUsing',
      netRegex: { id: '98DC', source: 'Drowsie' },
      response: Responses.tankBuster(),
    },
    {
      id: 'Ihuykatumu Drowsie Wallop Small',
      type: 'StartsUsing',
      netRegex: { id: '8E7F', source: 'Ihuykatumu Ivy', capture: false },
      delaySeconds: 2,
      suppressSeconds: 1,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Dodge Ivy cleaves (small)',
          de: 'Efeu-Cleave ausweichen (klein)',
          fr: 'Esquivez les cleaves du lierre (petit)',
          ja: '植物の直線範囲攻撃を避ける (小)',
          cn: '注意触手直线AoE (小)',
          ko: '식물의 직선 공격 피하기 (작음)',
          tc: '躲避觸手直線AOE (小)',
        },
      },
    },
    {
      id: 'Ihuykatumu Drowsie Wallop Large',
      type: 'StartsUsing',
      netRegex: { id: '8E82', source: 'Ihuykatumu Ivy', capture: false },
      delaySeconds: 2,
      suppressSeconds: 1,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Dodge Ivy cleaves (big)',
          de: 'Efeu-Cleave ausweichen (groß)',
          fr: 'Esquivez les cleaves du lierre (large)',
          ja: '植物の直線範囲攻撃を避ける (大)',
          cn: '注意触手直线AoE (大)',
          ko: '식물의 직선 공격 피하기 (큼)',
          tc: '躲避觸手直線AOE (大)',
        },
      },
    },
    {
      id: 'Ihuykatumu Drowsie Sneeze',
      type: 'StartsUsing',
      netRegex: { id: '8E7B', source: 'Drowsie', capture: false },
      response: Responses.awayFromFront(),
    },
    {
      id: 'Ihuykatumu Drowsie Flagrant Spread',
      type: 'HeadMarker',
      netRegex: { id: '008B' },
      condition: Conditions.targetIsYou(),
      response: Responses.moveAway(),
    },

    // ** Apollyon ** //
    {
      id: 'Ihuykatumu Apollyon Blade',
      type: 'StartsUsing',
      netRegex: { id: ['8DFB', '8E04'], source: 'Apollyon' },
      response: Responses.tankBuster(),
    },
    {
      id: 'Ihuykatumu Apollyon High Wind',
      type: 'StartsUsing',
      netRegex: { id: '8DF5', source: 'Apollyon', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Ihuykatumu Apollyon Swarming Locust First Cleaves',
      type: 'Ability',
      netRegex: { id: '8DF7', source: 'Apollyon', capture: false },
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Away on 3rd jump',
          de: 'Weg vom 3. Sprung',
          fr: 'Loin du 3ème saut',
          ja: '3回目のジャンプ目標地点から離れる',
          cn: '远离第三次跳跃落点',
          ko: '3번째 점프 지점에서 멀어지기',
          tc: '遠離第三次跳躍落點',
        },
      },
    },
    {
      id: 'Ihuykatumu Apollyon Swarming Locust Second Cleaves',
      type: 'Ability',
      netRegex: { id: '8DF7', source: 'Apollyon', capture: false },
      delaySeconds: 7.5,
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Away on 3rd jump',
          de: 'Weg vom 3. Sprung',
          fr: 'Loin du 3ème saut',
          ja: '3回目のジャンプ目標地点から離れる',
          cn: '远离第三次跳跃落点',
          ko: '3번째 점프 지점에서 멀어지기',
          tc: '遠離第三次跳躍落點',
        },
      },
    },
    {
      id: 'Ihuykatumu Apollyon Thunder III',
      type: 'HeadMarker',
      netRegex: { id: '006C' },
      condition: Conditions.targetIsYou(),
      response: Responses.spread(),
    },
    {
      id: 'Ihuykatumu Apollyon Wind Sickle',
      type: 'Ability',
      netRegex: { id: '8E05', source: 'Apollyon', capture: false },
      durationSeconds: 8,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'In, then follow jump',
          de: 'Rein, dann Sprüngen folgen',
          fr: 'Intérieur, puis suivez le saut',
          ja: 'ドーナツ、そしてボスを追いかける',
          cn: '进入月环 => 去BOSS身后',
          ko: '안으로, 그리고 보스 따라가기',
          tc: '進入月環 => 去Boss身後',
        },
      },
    },
    {
      id: 'Ihuykatumu Apollyon Windwhistle 1',
      type: 'Ability',
      netRegex: { id: '8E07', source: 'Apollyon', capture: false },
      delaySeconds: 7,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Avoid Whirlwind star lines',
          de: 'Wirbelwind-Sternenlinien vermeiden',
          fr: 'Évitez les lignes des étoiles de vent',
          ja: '風の8方向直線攻撃から避ける',
          cn: '注意风圈星形的直线AoE',
          ko: '회오리의 8방향 장판 피하기',
          tc: '躲避風圈星形的直線AOE',
        },
      },
    },
    {
      id: 'Ihuykatumu Apollyon Windwhistle 2',
      type: 'Ability',
      netRegex: { id: '8E07', source: 'Apollyon', capture: false },
      delaySeconds: 15,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Avoid Whirlwind star lines',
          de: 'Wirbelwind-Sternenlinien vermeiden',
          fr: 'Évitez les lignes des étoiles de vent',
          ja: '風の8方向直線攻撃から避ける',
          cn: '注意风圈星形的直线AoE',
          ko: '회오리의 8방향 장판 피하기',
          tc: '躲避風圈星形的直線AOE',
        },
      },
    },
    {
      id: 'Ihuykatumu Apollyon Windwhistle 3',
      type: 'Ability',
      netRegex: { id: '8E07', source: 'Apollyon', capture: false },
      delaySeconds: 23,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Avoid Whirlwind star lines',
          de: 'Wirbelwind-Sternenlinien vermeiden',
          fr: 'Évitez les lignes des étoiles de vent',
          ja: '風の8方向直線攻撃から避ける',
          cn: '注意风圈星形的直线AoE',
          ko: '회오리의 8방향 장판 피하기',
          tc: '躲避風圈星形的直線AOE',
        },
      },
    },
  ],
  timelineReplace: [
    {
      'locale': 'de',
      'replaceSync': {
        'Apollyon': 'Apollyon',
        'Drowsie': 'Schläfrich',
        'Green Clot': 'grün(?:e|er|es|en) Klumpen',
        'Ihuykatumu Flytrap': 'Ihuykatumu-Fliegenfalle',
        'Ihuykatumu Ivy': 'Ihuykatumu-Efeuranke',
        'Ihuykatumu Sandworm': 'Ihuykatumu-Sandwurm',
        'Prime Punutiy': 'Alpha-Punutiy',
        '(?<! )Punutiy': 'Punutiy',
      },
      'replaceText': {
        '\\(cast\\)': '(wirken)',
        '\\(inner ring\\)': '(innerer Ring)',
        '\\(large\\)': '(groß)',
        '\\(outer ring\\)': '(äußerer Ring)',
        '\\(puddle\\)': '(Fläche)',
        '\\(small\\)': '(klein)',
        'Arise': 'Erscheinung',
        'Blade(?!s )': 'Sense',
        'Blades of Famine': 'Heuschreckenklinge',
        'Bury': 'Impakt',
        'Cutting Wind': 'Windklinge',
        'Decay': 'Verwesung',
        'Drowsy Dance': 'Schläfriger Tanz',
        'High Wind': 'Starkböen',
        'Hydrowave': 'Hydro-Welle',
        'Levinsickle': 'Blitzsichel',
        'Punutiy Flop': 'Punutiy-Sprung',
        'Punutiy Press': 'Punutiy-Presse',
        'Razor Storm': 'Gewaltige Luftklinge',
        'Razor Zephyr': 'Luftklinge',
        'Resurface': 'Auftauchen',
        'Shore Shaker': 'Küstenbeben',
        'Sneeze': 'Großer Nieser',
        'Song of the Punutiy': 'Punutiy-Ruf',
        'Sow': 'Saat',
        'Spit': 'Ausspeien',
        'Swarming Locust': 'Heuschreckenschwarm',
        'Thunder III': 'Blitzga',
        'Uppercut': 'Aufwärtshaken',
        'Wallop': 'Eindreschen',
        'Wind Sickle': 'Windsichel',
        'Windwhistle': 'Windruf',
        'Wing of Lightning': 'Fächerentladung',
      },
    },
    {
      'locale': 'fr',
      'replaceSync': {
        'Apollyon': 'apollyon',
        'Drowsie': 'Somnolent',
        'Green Clot': 'caillot vert',
        'Ihuykatumu Flytrap': 'piège-mouche de l\'Ihuykatumu',
        'Ihuykatumu Ivy': 'lierre de l\'Ihuykatumu',
        'Ihuykatumu Sandworm': 'ver des sables de l\'Ihuykatumu',
        'Prime Punutiy': 'punutiy alpha',
        '(?<! )Punutiy': 'punutiy',
      },
      'replaceText': {
        '\\(cast\\)': '(Incantation)',
        '\\(inner ring\\)': '(Anneau intérieur)',
        '\\(large\\)': '(Large)',
        '\\(outer ring\\)': '(Anneau extérieur)',
        '\\(puddle\\)': '(Flaque)',
        '\\(small\\)': '(Petit)',
        'Arise': 'Apparition',
        'Blade(?!s )': 'Ravisseuse',
        'Blades of Famine': 'Lames locustes',
        'Bury': 'Impact',
        'Cutting Wind': 'Lame du vent',
        'Decay': 'Décomposition',
        'Drowsy Dance': 'Danse de Somnolent',
        'High Wind': 'Grands vents',
        'Hydrowave': 'Hydro-vague',
        'Levinsickle': 'Faucilles foudroyantes',
        'Punutiy Flop': 'Bond punutiy',
        'Punutiy Press': 'Aplatissement punutiy',
        'Razor Storm': 'Vent tranchant massif',
        'Razor Zephyr': 'Vent tranchant',
        'Resurface': 'Turbinage',
        'Shore Shaker': 'Secousse côtière',
        'Sneeze': 'Éternuement',
        'Song of the Punutiy': 'Appel punutiy',
        'Sow': 'Semence',
        'Spit': 'Crachat morbide',
        'Swarming Locust': 'Nuée de locustes',
        'Thunder III': 'Méga Foudre',
        'Uppercut': 'Uppercut',
        'Wallop': 'Rossée',
        'Wind Sickle': 'Faucilles foudroyantes',
        'Windwhistle': 'Appel du vent',
        'Wing of Lightning': 'Décharge en éventail',
      },
    },
    {
      'locale': 'ja',
      'replaceSync': {
        'Apollyon': 'アポリオン',
        'Drowsie': 'ドラウジー',
        'Green Clot': 'グリーンクロット',
        'Ihuykatumu Flytrap': 'イフイカ・フライトラップ',
        'Ihuykatumu Ivy': 'イフイカ・アイビー',
        'Ihuykatumu Sandworm': 'イフイカ・サンドウォーム',
        'Prime Punutiy': 'アルファ・プヌティー',
        '(?<! )Punutiy': 'プヌティー',
      },
      'replaceText': {
        'Arise': '出現',
        'Blade(?!s )': 'カマ',
        'Blades of Famine': 'ローカストブレイド',
        'Bury': '衝撃',
        'Cutting Wind': '風刃',
        'Decay': 'ディケイ',
        'Drowsy Dance': 'ドラウジーダンス',
        'High Wind': 'ハイウィンド',
        'Hydrowave': 'ハイドロウェーブ',
        'Levinsickle': 'ライトニングシックル',
        'Punutiy Flop': 'プヌティーリープ',
        'Punutiy Press': 'プヌティープレス',
        'Razor Storm': 'マッシブ・エアレイザー',
        'Razor Zephyr': 'エアレイザー',
        'Resurface': 'リサーフェス',
        'Shore Shaker': 'ショアシェイカー',
        'Sneeze': 'くしゃみ',
        'Song of the Punutiy': 'プヌティーコール',
        'Sow': '種まき',
        'Spit': '吐出す',
        'Swarming Locust': 'ローカストスウォーム',
        'Thunder III': 'サンダガ',
        'Uppercut': 'アッパーカット',
        'Wallop': '叩きつけ',
        'Wind Sickle': 'ウィンドシックル',
        'Windwhistle': '風呼び',
        'Wing of Lightning': '扇状放電',
      },
    },
    {
      'locale': 'cn',
      'replaceSync': {
        'Apollyon': '亚波伦',
        'Drowsie': '瞌睡怪',
        'Green Clot': '绿色凝块',
        'Ihuykatumu Flytrap': '生息陷阱草',
        'Ihuykatumu Ivy': '生息藤蔓大口花',
        'Ihuykatumu Sandworm': '生息沙虫',
        'Prime Punutiy': '首领海牛',
        '(?<! )Punutiy': '海牛',
      },
      'replaceText': {
        '\\(cast\\)': '(咏唱)',
        '\\(inner ring\\)': '(内环)',
        '\\(large\\)': '(大)',
        '\\(outer ring\\)': '(外环)',
        '\\(puddle\\)': '(圈)',
        '\\(small\\)': '(小)',
        'Arise': '出现',
        'Blade(?!s )': '镰击',
        'Blades of Famine': '飞蝗之刃',
        'Bury': '塌方',
        'Cutting Wind': '风刃',
        'Decay': '腐烂',
        'Drowsy Dance': '瞌睡舞',
        'High Wind': '强风',
        'Hydrowave': '水化波动',
        'Levinsickle': '闪电镰',
        'Punutiy Flop': '海牛猛跃',
        'Punutiy Press': '海牛重压',
        'Razor Storm': '空气绞割',
        'Razor Zephyr': '空气削割',
        'Resurface': '重吐于世',
        'Shore Shaker': '地动岸摇',
        'Sneeze': '喷嚏',
        'Song of the Punutiy': '海牛之声',
        'Sow': '播种',
        'Spit': '呕吐',
        'Swarming Locust': '单蝗成群',
        'Thunder III': '暴雷',
        'Uppercut': '上击',
        'Wallop': '敲击',
        'Wind Sickle': '风镰',
        'Windwhistle': '唤风',
        'Wing of Lightning': '扇状放电',
      },
    },
    {
      'locale': 'tc',
      'replaceSync': {
        'Apollyon': '亞巴頓',
        'Drowsie': '瞌睡怪',
        'Green Clot': '綠色凝塊',
        'Ihuykatumu Flytrap': '生息陷阱草',
        'Ihuykatumu Ivy': '生息藤蔓食腐獸',
        'Ihuykatumu Sandworm': '生息沙蟲',
        'Prime Punutiy': '首領海牛',
        '(?<! )Punutiy': '海牛',
      },
      'replaceText': {
        '\\(cast\\)': '(詠唱)',
        '\\(inner ring\\)': '(內環)',
        '\\(large\\)': '(大)',
        '\\(outer ring\\)': '(外環)',
        '\\(puddle\\)': '(圈)',
        '\\(small\\)': '(小)',
        'Arise': '出現',
        'Blade(?!s )': '鐮擊',
        'Blades of Famine': '飛蝗之刃',
        'Bury': '塌方',
        'Cutting Wind': '風刃',
        'Decay': '腐爛',
        'Drowsy Dance': '瞌睡舞',
        'High Wind': '強風',
        'Hydrowave': '水化波動',
        'Levinsickle': '閃電鐮',
        'Punutiy Flop': '海牛猛躍',
        'Punutiy Press': '海牛重壓',
        'Razor Storm': '空氣絞割',
        'Razor Zephyr': '空氣削割',
        'Resurface': '重吐於世',
        'Shore Shaker': '地動岸搖',
        'Sneeze': '噴嚏',
        'Song of the Punutiy': '海牛之聲',
        'Sow': '播種',
        'Spit': '嘔吐',
        'Swarming Locust': '單蝗成群',
        'Thunder III': '大雷電',
        'Uppercut': '上擊',
        'Wallop': '打擊',
        'Wind Sickle': '風鐮',
        'Windwhistle': '喚風',
        'Wing of Lightning': '扇狀放電',
      },
    },
    {
      'locale': 'ko',
      'replaceSync': {
        'Apollyon': '아폴리온',
        'Drowsie': '졸음보',
        'Green Clot': '초록 멍울',
        'Ihuykatumu Flytrap': '이후이카 파리풀',
        'Ihuykatumu Ivy': '이후이카 담쟁이',
        'Ihuykatumu Sandworm': '이후이카 모래지렁이',
        'Prime Punutiy': '우두머리 푸누티',
        '(?<! )Punutiy': '푸누티',
      },
      'replaceText': {
        '\\(cast\\)': '(시전)',
        '\\(inner ring\\)': '(안쪽)',
        '\\(large\\)': '(큰)',
        '\\(outer ring\\)': '(바깥쪽)',
        '\\(puddle\\)': '(장판)',
        '\\(small\\)': '(작은)',
        'Arise': '출현',
        'Blade(?!s )': '낫날',
        'Blades of Famine': '메뚜기 낫질',
        'Bury': '충격',
        'Cutting Wind': '바람날',
        'Decay': '부식',
        'Drowsy Dance': '졸음보 춤',
        'High Wind': '거센 바람',
        'Hydrowave': '수력 파동',
        'Levinsickle': '번개 낫질',
        'Punutiy Flop': '푸누티 도약',
        'Punutiy Press': '푸누티 내리찍기',
        'Razor Storm': '날카로운 폭풍',
        'Razor Zephyr': '날카로운 바람',
        'Resurface': '침전물 부상',
        'Shore Shaker': '기슭 흔들기',
        'Sneeze': '재채기',
        'Song of the Punutiy': '푸누티 부르기',
        'Sow': '씨뿌리기',
        'Spit': '뱉기',
        'Swarming Locust': '메뚜기 뜀박질',
        'Thunder III': '선더가',
        'Uppercut': '올려치기',
        'Wallop': '매질',
        'Wind Sickle': '바람 낫질',
        'Windwhistle': '바람 부르기',
        'Wing of Lightning': '부채꼴 방전',
      },
    },
  ],
};

export default triggerSet;
